<template>
  <div class="teamrewards">
    <toptitle :title1="titlework" />

    <form action="/">
      <van-search v-model="value"
                  placeholder="请搜索用户"
                  @search="onSearch"
                  @input="inputSearch">
        <template #action>
          <div @click="onCancel">取消</div>
        </template>
      </van-search>
    </form>

    <section v-show="emptyShow">
      <van-empty description="暂无数据" />
    </section>
    <van-list class
              @load="loadMore"
              :finished="loadFinished"
              finished-text="没有更多了">
      <section class="fix"
               v-for="(item,index) in teamSalaryData"
               :key="index">
        <div class="fix-divplay">

          <div class="divimg">
            <img class="img-carcle"
                 v-if="item.PHOTO != ''"
                 :src="`data:image/png;base64,${item.PHOTO}`"
                 alt="" />
            <div class="divnameone"
                 v-else>{{ item.NAME | cutName }}</div>
          </div>

          <div class="divInfo">
            <p class="divname">{{ item.NAME }}</p>
            <!-- <p class="divname">应发工资：{{ item.PAY }}</p>
            <p class="divname">月标准工资：{{ item.STAND }}</p> -->
          </div>
          <div class="teamSon">
            <p>{{ item.POSN }}</p>

          </div>
        </div>

        <div class="payNumber">
          <p>月标准工资：{{ item.STAND }} 元</p>
          <p>应发工资：{{ item.PAY }} 元</p>
        </div>
      </section>
    </van-list>
    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
import toptitle from '../components/toptitle'
import LoadingShow from '../components/loading'
import { getTeamSalaryData } from '../request/api'
export default {
  name: 'teamrp',
  data() {
    return {
      titlework: '团队薪酬成本',
      value: '',
      currentPageNo: 1,
      maxPageNo: 0,
      loading: false,
      loadFinished: false,
      emptyShow: false,
      teamSalaryData: [],
    }
  },
  mounted() {
    this.getTeamList('', '10000')
  },
  methods: {
    onSearch() {},
    /**
     * 搜索部门
     * **/
    inputSearch() {
      this.currentPageNo = 1
      if (this.value.length > 0) {
        this.getTeamList(this.value, '15')
      } else {
        this.getTeamList('', '15')
      }
    },
    onCancel() {
      this.value = ''
      this.getTeamList('', '10000')
    },
    loadMore() {
      if (this.currentPageNo > this.maxPageNo) {
        //已经加载到了最后一页
        this.loadFinished = true
      } else {
        //加载下一页的数据
        this.currentPageNo++
        this.getTeamList('', '10000')
      }
    },
    /**
     * 团队薪酬详情
     * **/
    getTeamList(value, num) {
      this.loading = true
      let params = {
        EMPLID: sessionStorage.getItem('EMPLID'),
        DEPTID: this.$route.query.DEPTID,
        DATE: this.$route.query.CURR_DATE,
        PAGE: this.currentPageNo,
        RECORD: 10,
        NAME: this.value,
      }
      getTeamSalaryData(params).then((res) => {
        if (res.CODE === 200) {
          let subBody = res.DATA.INFO
          this.maxPageNo = parseInt(res.DATA.MAXPAGE)
          if (this.currentPageNo >= this.maxPageNo) {
            this.loadFinished = true
          } else {
            this.loadFinished = false
          }
          if (this.currentPageNo == 1) {
            //如果当前是第一页，清空相关数据
            this.teamSalaryData = []
          }
          this.teamSalaryData = this.teamSalaryData.concat(subBody)
          this.teamSalaryData.forEach((item) => {
            item.PHOTO = item.PHOTO.replace(/<br>/g, '')
          })
          if (this.teamSalaryData == 0) {
            this.emptyShow = true
          } else {
            this.emptyShow = false
          }
          this.loading = false
        }
      })
    },
  },
  components: {
    toptitle,
    LoadingShow,
  },
  filters: {
    cutName(val) {
      return val.slice(0, 1)
    },
  },
  created() {
    console.log(this.$route.query, 'query')
  },
}
</script>

<style  lang="less" scoped>
.fix {
  background: white;
  margin: 10px 14px 0;
  padding: 12px 14px;
  color: #8f8f8f;
  line-height: 27px;
  font-size: 14px;

  .fix-divplay {
    display: flex;
    justify-content: flex-start;
    border-radius: 10px;
  }
  .fix-top {
    display: flex;
    .approve1 {
      background: #dbefe2;
      color: #4ab16d;
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .approve2 {
      background: #d9e5ff;
      color: #427cff;
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .approve3 {
      background: #e48e96;
      color: rgb(230, 3, 3);
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .number {
      text-align: right;
      flex: 1;
      span {
        color: black;
      }
    }
  }
}
.divnameone {
  margin-top: 0px;
}
.divimg {
  width: 50px;
  height: 50px;
  background: #55a0f8;
  box-sizing: border-box;
  border-radius: 50%;
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    // overflow: hidden;
  }
  text-align: center;
  line-height: 50px;
  font-size: 18px;

  color: white;
  .divnameone {
    margin-top: 0px;
  }
}
.divInfo {
  width: 45%;
  padding-left: 5%;
}
.divname {
  color: #333;
  line-height: 50px;
}
.teamSon {
  P {
    color: #333;
    line-height: 50px;
  }
}
.payNumber {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ccc;
  padding-top: 5px;
  margin-top: 5px;
}
.van-empty {
  background: #fff;
}
</style>